module.exports = "pegasus_template/assets/blocks/column-1-theme3.png";